import { render } from "./EditContact.vue?vue&type=template&id=20997973"
import script from "./EditContact.vue?vue&type=script&lang=js"
export * from "./EditContact.vue?vue&type=script&lang=js"
script.render = render

export default script